export const INSIGHT_TYPES = {
  DATETIME: 'datetime',
  BOOLEAN: 'boolean',
  CATEGORICAL: 'categorical',
  INTEGER: 'int',
  NUMBER: 'number',
  STRING: 'string',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone_number',
} as const;

export interface Datable {
  readonly created: string;
  readonly updated: string;
}

export interface Insight extends Datable {
  readonly insight_id: string;
  readonly brain_id: string;
  name: string;
  description: string;
  type: (typeof INSIGHT_TYPES)[keyof typeof INSIGHT_TYPES];
  categories?: string[];
}

export interface Insights {
  insights: Insight[];
}
